<template>
  <v-banner
    class="banner-container"
    :class="{
      'has-detail': detail,
    }"
    single-line
    full-width
    dense
    :color="bannerColor"
  >
    <v-icon
      v-if="icon"
      left
      color="#000"
    >
      {{ icon }}
    </v-icon>
    <div class="text-content">
      <div class="message">
        {{ message }}
      </div>
      <div
        v-if="detail"
        class="detail"
      >
        {{ detail }}
      </div>
    </div>
    <template #actions>
      <v-btn
        v-if="action && action.text"
        :to="action.to"
        text
        small
        :color="actionColor"
      >
        {{ action.text }}
      </v-btn>
    </template>
  </v-banner>
</template>
<script>
import variables from '../../../styles/_variables.scss';

export default {
  name: 'Banner',
  props: {
    message: { type: String, default: 'This is a banner message.' },
    detail: { type: String, default: '' },
    action: { type: Object, default: () => ({}) },
    icon: { type: String, default: '' },
  },
  computed: {
    actionColor() { return variables.tealDark; },
    bannerColor() { return variables.yellowLighter; },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.banner-container {
  width: stretch;
  background-color: $dark-grey;
  color: $black;
  font-size: 0.875rem;
  button, a {
    font-size: 0.875rem;
    font-weight: bold;
  }
  .text-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .detail {
      font-size: 0.75rem;
    }
  }
  &.has-detail .text-content  {
    margin-top: -5px;
    margin-bottom: -5px;
  }
}
</style>
<style lang="scss">
.banner-container {
  .v-banner__text {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  &.has-detail {
    .v-banner__wrapper {
      // Adjust padding to accommodate detail text
      padding-top: 9px;
      padding-bottom: 7px;
    }
  }
  .v-banner__actions  {
    margin-left: 10px !important;
  }
}
</style>
